import { useEffect, useRef, useState } from 'react';
import { useFederatedScript } from 'common/components/FederatedMFE/useFederatedScript';
import importFederatedModule from 'common/components/FederatedMFE/importFederatedModule';

export const useFederatedComponent = (
  remoteUrl: string,
  scope: string,
  module: string
) => {
  const [, setComponentsRetrieved] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const injectRef = useRef<any>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cleanupRef = useRef<any>(null);

  const { ready, error } = useFederatedScript(remoteUrl);

  useEffect(() => {
    if (ready) {
      const loadMfeModule = async () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const data = (await importFederatedModule(scope, module)()) as any;
        injectRef.current = data.inject;
        cleanupRef.current = data.cleanup;
        setComponentsRetrieved(true);
      };
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      loadMfeModule();
    }
  }, [ready, scope, module]);

  return {
    error,
    injectFunc: injectRef.current,
    cleanupFunc: cleanupRef.current,
  };
};
